<div>
  @for (notification of displayedNotifications(); track notification.id) {
  <phar-event-notification class="my-3" [eventNotification]="notification" [draftMode]="draftMode()"
    [disabled]="disabled()" (deleteNewNotification)="handleDeleteNotification(notification.id!)"
    (formValueChanges)="handleFormValueChanges($event, notification.id!)">
    <span notificationTitle>
      <phar-event-notification-header [notification]="notification" />
    </span>
  </phar-event-notification>
  }

  @if (newNotification) {
  <phar-event-notification class="my-3" [eventNotification]="newNotification" [disabled]="disabled()"
    [draftMode]="draftMode()" (createNewNotification)="createNewNotification($event)"
    (deleteNewNotification)="newNotification = null">
    <span notificationTitle>{{ 'STUDY.EVENTS.NOTIFICATIONS.NEW_NOTIFICATION' | translate }}</span>
  </phar-event-notification>
  }

  @let shouldDisable = this.draftMode() ? this.draftNotificationsInvalid() : disabled();
  @if (!shouldDisable) {
  <div class="text-center w-100">
    <p-button severity="secondary" variant="outlined" icon="pi pi-plus"
      [label]="'STUDY.EVENTS.NOTIFICATIONS.ADD_NOTIFICATION' | translate" (onClick)="addNotification()" />
  </div>
  }
</div>